<div class="pr-xlarge-b table-wrapper">
  <table>
    <caption class="is-vishidden">
      {{
        'timetable.flightList.caption' | finLocalization
      }}
    </caption>
    <tbody>
      <tr class="nordic-blue-900-bg surface-contrast nordic-blue-900-border border-primary">
        <th
          scope="col"
          class="ps-xsmall-y pr-xxsmall-x font-body-2 medium-type align-center rounded-top-large rounded-top-left-large white-text text-icon-reversed font-label-small"
        >
          {{ 'timetable.flightList.flight' | finLocalization }}
        </th>
        <th
          scope="col"
          class="ps-xsmall-y pr-xxsmall-x font-body-2 medium-type align-center white-text text-icon-reversed font-label-small"
        >
          {{ 'timetable.flightList.departure' | finLocalization }}
        </th>
        <th scope="col" class="ps-xsmall-y"></th>
        <th
          scope="col"
          class="ps-xsmall-y pr-xxsmall-x font-body-2 medium-type align-center white-text text-icon-reversed font-label-small"
        >
          {{ 'timetable.flightList.arrival' | finLocalization }}
        </th>
        <th
          scope="col"
          class="ps-xsmall-y pr-small-x font-body-2 medium-type align-center white-text text-icon-reversed font-label-small"
        >
          {{ 'timetable.flightList.duration' | finLocalization }}
        </th>
        <th scope="col" class="ps-xsmall-y pr-xxsmall-x rounded-top-large rounded-top-right-large"></th>
      </tr>
      @if (items().length === 0) {
        <tr class="border">
          <td
            colspan="6"
            class="border-bottom border-left border-right rounded-bottom-left-large rounded-bottom-right-large"
          >
            @if (!loading()) {
              <div class="ms-medium nordic-blue-900-text text-icon-primary font-body-1 font-body-medium">
                {{
                  (originCode() && destinationCode() ? 'timetable.flightList.noFlights' : selectDateKey())
                    | finLocalization
                }}
              </div>
            }
          </td>
        </tr>
      }
      @for (item of items(); track item; let i = $index; let lastRow = $last) {
        <tr
          role="button"
          tabindex="0"
          class="mr-xsmall-b border schedule-item"
          [attr.aria-labelledby]="'flightSummaryDetailsText-' + i"
          (click)="openModal($event, item)"
          (keyup)="rowKeyPress($event, item)"
        >
          @if (item.flights; as flights) {
            <td
              class="pr-xxsmall-x ps-medium-y border-left"
              [ngClass]="{
                'border-bottom': lastRow,
                'rounded-bottom-left-large': lastRow,
              }"
            >
              @for (flight of flights; track $index) {
                <div class="flex-1 flex--middle font-body-1 nordic-blue-900-text text-icon-primary font-body-medium">
                  {{ flight.flightNumber }}
                </div>
              }
            </td>
            <td
              class="pr-xxsmall-x ps-medium-y align-center"
              [ngClass]="{
                'border-bottom': lastRow,
              }"
            >
              @for (flight of flights; track $index) {
                <div
                  class="flex--center font-body-1 medium-type nordic-blue-900-text text-icon-primary font-label-medium"
                >
                  {{ flight.departureTime }}
                </div>
              }
            </td>
            <td
              class="ps-medium-y align-center"
              [ngClass]="{
                'border-bottom': lastRow,
              }"
            >
              <div class="flex flex--column">
                @for (flight of flights; track $index) {
                  <div>
                    <fcom-icon [name]="flight.icon" class="flex--nogrow flex--middle" />
                  </div>
                }
              </div>
            </td>
            <td
              class="pr-xxsmall-x ps-medium-y align-center"
              [ngClass]="{
                'border-bottom': lastRow,
              }"
            >
              @for (flight of flights; track $index) {
                <div class="flex flex--center">
                  <div
                    class="flex--center font-body-1 medium-type nordic-blue-900-text text-icon-primary relative float-left font-label-medium"
                  >
                    {{ flight.arrivalTime }}
                    @if (flight.overnight) {
                      <div
                        class="flex--self-start absolute font-body-2 nordic-blue-900-text text-icon-primary ps-xxsmall-l plus-one font-body-small"
                      >
                        +1
                      </div>
                    }
                  </div>
                </div>
              }
            </td>
            <td
              class="pr-small-x ps-medium-y align-center"
              [ngClass]="{
                'border-bottom': lastRow,
              }"
            >
              <div
                class="flex-1 flex--center truncate overflow-hidden font-body-1 nordic-blue-900-text text-icon-primary font-body-medium"
              >
                {{ item.duration.hours + 'h ' + item.duration.minutes + 'min' }}
              </div>
            </td>
            <td
              class="border-right"
              [ngClass]="{
                'border-bottom': lastRow,
                'rounded-bottom-right-large': lastRow,
              }"
            >
              <div class="flex flex--end">
                <p [id]="'flightSummaryDetailsText-' + i" class="is-vishidden">
                  {{
                    'timetable.flightSummaryDetails'
                      | finLocalization
                        : {
                            origin: (item.origin$ | async) ?? '',
                            departureTime: item.departureTime,
                            destination: (item.destination$ | async) ?? '',
                            arrivalTime: item.arrivalTime,
                            durationTime: item.duration.hours + 'h ' + item.duration.minutes + 'min',
                          }
                  }}
                </p>
                <span
                  class="dn-mobile db-tablet-up font-body-1 nordic-blue-900-text text-icon-primary blue-light-hover medium-type underline truncate overflow-hidden font-label-medium"
                >
                  {{ 'timetable.viewDetails' | finLocalization }}
                  <fcom-icon [name]="SvgLibraryIcon.CHEVRON_RIGHT" class="flex--nogrow flex--middle" />
                </span>
                <span class="db-mobile dn-mobile-up">
                  <fcom-icon [name]="SvgLibraryIcon.CHEVRON_RIGHT" class="flex--nogrow flex--middle" />
                </span>
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
<fcom-modal
  [title]="'timetable.flightList.viewDetails.title' | finLocalization"
  [buttons]="null"
  [(open)]="detailsModalOpen"
  (close)="closeModal()"
>
  @if (selectedBound(); as bound) {
    <fin-itinerary-timeline
      [bound]="bound"
      [locations]="locations()"
      [boundType]="BoundType.outbound"
      class="block pr-medium"
    />
  }
</fcom-modal>
